import React, { SVGProps } from 'react'
export const FifthDefaultCenterSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="36"
    fill="none"
    preserveAspectRatio="none"
    viewBox="0 0 74 36"
    {...props}
  >
    <path
      fill="#7F7472"
      fillRule="evenodd"
      d="M16.033 1C12.798 1 4.317 1.222 0 2V1C4.416.205 12.803 0 16.033 0c5.806 0 11.095.161 16.185.316 7.557.23 14.674.448 22.387.103C59.804-.113 67.072.02 74 1v1c-6.865-.972-14.198-1.109-19.307-.584l-.014.001h-.014c-7.742.347-14.94.129-22.542-.102C27.036 1.16 21.767 1 16.033 1Z"
      clipRule="evenodd"
    />
    <path
      fill="#7F7472"
      d="M0 34c13.552.785 27.706.938 41.01.938 2.122 0 4.314.022 6.546.043 8.722.085 18.134.172 26.444-.981v1c-8.394 1.165-17.766 1.039-26.494.953a669.963 669.963 0 0 0-6.497-.043C27.701 35.91 13.582 35.787 0 35v-1Z"
    />
  </svg>
)
